import { isApplePlatform } from '~/utils/isApplePlatform'
import type { KeyboardShortcut, UserPreferencesPayload } from '~/utils/userPreferences/types'

function defaultShortcut(shortcutKey: string): KeyboardShortcut {
  return {
    key: shortcutKey,
    meta: false,
    ctrl: true,
    shift: false,
    alt: false,
  }
}

function defaultEditModeShortcut(): KeyboardShortcut {
  const isMac = isApplePlatform()
  return {
    key: 'e',
    meta: isMac,
    ctrl: !isMac,
    shift: true,
    alt: false,
  }
}

export function defaultUserPreferences(): UserPreferencesPayload {
  const isMac = isApplePlatform()
  return {
    version: 1,
    updatedAt: Date.now(),
    colorModePreference: 'system',
    welcomeSplashDone: false,
    shortcuts: {
      toolboxToggle: {
        ...defaultShortcut('k'),
        meta: isMac,
        ctrl: !isMac,
      },
      geolocate: {
        ...defaultShortcut('g'),
        meta: isMac,
        ctrl: !isMac,
      },
      editModeToggle: defaultEditModeShortcut(),
    },
  }
}
